const variables = {
  mainNavigationLargeHeight: 120,
  mainNavigationLargeMarginTop: 8,
  mainNavigationLargeProfileMenuButtonVariant: 'ghost',
  mainNavigationSmallHeight: 56,
  mainNavigationSmallMarginTop: 8,
  mainNavigationSmallMenuButtonPosition: 'start',
  mainNavigationSmallProfileMenuButtonVariant: 'ghost',
};

export default variables;
